// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1gMAxi_pbLeQrFU3sEJNUE","container":"_3UIlUwkWh654olFzAGcynn","row":"_3vIUsToqaPW9fNidtdDm5Y","heading":"_1j06KwRzuRYq0zsDwJg8m3","title-cell":"_1W4abKIc7ORsYlGZtN0nBq","cell":"_1LYCP0j3uNbl-4_JyMFZSN","mobile":"_2k72cF1xmVHmv4KbIjRfkB","inner-row":"_1qPe4tbf_NPqTX0N8mNyUt","hidden":"_2GiZBs6BpnVVpkloBeSca9"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/SatisfactionTable.mod.css
// module id = 1711
// module chunks = 0